import cookie from 'js-cookie'
import 'intl';
import Api from '../Config/Api';
import MasterApi from '../Config/MasterApi';

export function StatusCustomer(statusCustomer,isUnitLink) {
    if(isUnitLink == 1)
    {
        switch (statusCustomer) {
            case "D": 
                return 1 // DRAFT - START DARI ILLUSTRASI
            case "CI": 
                return 2 // COMPLETE ILLUSTRASI - START DARI SPAJ
            case "CS": 
                return 3 // COMPLETE SPAJ - START DARI PERNYATAAN NASABAH
            case "CP":
                return 4 // COMPLETE PERNYATAAN NASABAH - START DARI PERSETUJUAN
            case "C":
                return 6 // COMPLETE PERSETUJUAN - START DARI VIDEO
            case "INP":
                return "INP"
            case "INP":
                return "INP"
            case "IN":
                return "IN"
            case "PE":
                return 6
            case "P":  // COMPLETE PERSETUJUAN - START DARI VIDEO
                return 6
            case "PEP": 
                return 7
            case "PDC": // Pending Document - Periksa dan Kirim Dokumen Susulan
                return 8
            default:
                return 1
        }
    }
    else if (isUnitLink == 0)
    {
        switch (statusCustomer) {
            case "D": 
                return 1 // DRAFT - START DARI ILLUSTRASI
            case "CI": 
                return 2 // COMPLETE ILLUSTRASI - START DARI SPAJ
            case "CS": 
                return 3 // COMPLETE SPAJ - START DARI PERNYATAAN NASABAH
            case "CP":
                return 4 // COMPLETE PERNYATAAN NASABAH - START DARI PERSETUJUAN
            case "C":
                return 5 // COMPLETE PERSETUJUAN - START DARI PEMBAYARAN
            case "INP":
                return "INP"
            case "INP":
                    return "INP"
            case "IN":
                return "IN"
            case "PE":
                return 6
            case "P": 
                return 5 // COMPLETE PERSETUJUAN - START DARI PEMBAYARAN
            case "PEP": 
                return 7
            case "PDC": // Pending Document - Periksa dan Kirim Dokumen Susulan
                return 8
            default:
                return 1
        }
    }
}

export const getAddDays = (dateOld, days) => {
    var date = new Date(dateOld);
    date.setDate(date.getDate() + parseInt(days));

    var month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}


export const logoutClose = (deviceid) => {
    // let token = cookie.get("accessToken")
    // let token = JSON.parse(localStorage.getItem("TOKEN")).Token;
    // var params = new FormData();
    // params.append('spajNumber', JSON.parse(localStorage.getItem("SPAJ_HEADER")).spajNumber);
    // params.append('username', JSON.parse(localStorage.getItem("SPAJ_HEADER")).userName);
    // params.append('deviceid', deviceid);
    // params.append('x', token);
    // const eventHandler = () => {
    //     let time = new Date(localStorage.getItem("BEFOREUNLOAD_REFRESH"))
    //     let timeNew = new Date();
    //     let refreshTime = (timeNew.getTime() - time.getTime()) / 1000

    //     if (refreshTime >= 5) {
    //         navigator.sendBeacon("https://via.generali.co.id/uat-youHelper/helper/customer/logoutClose", params)
    //         localStorage.removeItem("SPAJ_HEADER");
    //         cookie.remove('accessToken');
    //         cookie.remove('refreshToken');
    //         localStorage.removeItem("TOKEN");
    //         sessionStorage.removeItem('tokenPayment')
    //     }
    // }

    // const eventHandler1 = () => {
    //     localStorage.setItem("BEFOREUNLOAD_REFRESH", new Date());
    // }

    // window.addEventListener('beforeunload', eventHandler1, true)
    // window.addEventListener('load', eventHandler, true)
    // return () => {
    //     window.addEventListener('beforeunload', eventHandler1, true)
    //     window.removeEventListener('load', eventHandler, true)
    // }
}

export const getToday = () => {
    var d = new Date(),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
}

export const getTime = () => {
    var date = new Date();
    let hours = date.getHours() < 10 ? "0" + date.getHours().toString() : date.getHours();
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes().toString() : date.getMinutes();

    const hoursAndMinutes = hours + ":" + minutes;

    return hoursAndMinutes;
}

const formatter = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 2
})

export const formatCurrency = (value, prefix) => {
    if (prefix) {
        return formatter.format(value).replace("Rp", "Rp ");
    } else {
        return formatter.format(value).replace("Rp", "");
    }
}

export const formatCurrencyNew = (value, prefix, currency) => {
    let curr  = currency === "USD" ? 'USD' : "Rp"
    if (prefix) {
        return formatter.format(value).replace(`Rp`,`${curr} `);
    } else {
        return formatter.format(value).replace(`Rp`, ``);
    }
}

export const logoutWhenIdle = (data, deviceId) => {
    let minutes = data.find(row => row.codeSetting == "AUTO_LOGOUT").valueSetting;
    let spajHash = localStorage.getItem("spajHash");

    let dataMouse = {
        mouseX: "",
        mouseY: "",
        time: new Date()
    }
    localStorage.setItem("IDLE_MOUSE", JSON.stringify(dataMouse));

    window.addEventListener("mousemove", (event) => {
        let dataMouse = {
            mouseX: event.clientX,
            mouseY: event.clientY,
            time: new Date()
        }
        localStorage.setItem("IDLE_MOUSE", JSON.stringify(dataMouse));
    });

    let interval = setInterval(() => {
        let dataMouse = JSON.parse(localStorage.getItem("IDLE_MOUSE"));
        let lateTime = new Date(dataMouse.time);
        let expiredTime = new Date(lateTime.getTime() + parseInt(minutes) * 60000)
        let today = new Date();

        if (today > expiredTime) {
            clearInterval(interval);

            let tmpReq = {
                deviceid: deviceId,
                username: JSON.parse(localStorage.getItem("SPAJ_HEADER")).userName,
                spajNumber: JSON.parse(localStorage.getItem("SPAJ_HEADER")).spajNumber
            }

            Api.post(Api.routeHelper+MasterApi.LogOut, tmpReq)
                .then(response => {
                    localStorage.removeItem("SPAJ_HEADER");
                    cookie.remove('accessToken');
                    cookie.remove('refreshToken');
                    localStorage.removeItem("TOKEN");
                    sessionStorage.removeItem('tokenPayment')

                    window.location = "/" + spajHash;
                })
                .catch(err => {
                    return err
                })
        }
    }, 1000);
}